/* global gtag */
// The following relies on the global gtag variable being set by the main webapp

export const sendAnswerToGoogleAnalytics = (treatmentCategory, answerId, responseType) => {
  if (typeof gtag !== 'undefined') {
    const urlReadyTreatmentCategory = treatmentCategory || '';
    const urlReadyAnswerId = answerId || '';
    const url = `/virtual/consultation/qpp/${urlReadyTreatmentCategory}/answers/${urlReadyAnswerId}`;
    gtag('event', 'virtual_page_view', {
      event_category: url,
      event_label: responseType,
      value: 1,
    });
  }
};

export const sendQuestionToGoogleAnalytics = (treatmentCategory, questionId, isValidationError, isSuccessfulSubmit, responseType) => {
  if (typeof gtag !== 'undefined') {
    const urlReadyTreatmentCategory = treatmentCategory || '';
    const urlReadyQuestionId = questionId || '';
    let url = `/virtual/consultation/qpp/${urlReadyTreatmentCategory}/${urlReadyQuestionId}`;
    if (isValidationError) {
      url += '/VALIDATION_ERROR';
    }
    if (isSuccessfulSubmit) {
      url += '/SUCCESSFUL_SUBMIT';
    }
    gtag('event', 'virtual_page_view', {
      event_category: url,
      event_label: responseType,
      value: 1,
    });
  }
};

export const sendCancelUrgentEmergencyEventToGoogleAnalytics = isUrgentWarning => {
  if (typeof gtag !== 'undefined') {
    gtag('event', isUrgentWarning ? 'cancel_urgent_warning' : 'cancel_emergency_warning', {
      event_category: 'click',
      event_label: 'emergency actions',
      value: 1,
    });
  }
};

export const sendImageUploadSizeLimitReachedEventToGoogleAnalytics = () => {
  if (typeof gtag !== 'undefined') {
    gtag('event', 'image_size_limit_reached', {
      event_category: 'image_upload',
      event_label: 'consultation image upload',
      value: 1,
    });
  }
};
